/* eslint-disable functional/immutable-data */
import type { ICalendarEvent, WorkScheduleListToCalendarEventsParams } from "../interfaces";


function splitEventAcrossDays(event: ICalendarEvent): ICalendarEvent[] {
  const startDate = event.start;
  const endDate = event.end;

  const isSameDay = startDate.toPlainDate().equals(endDate.toPlainDate());

  if (isSameDay) {
    return [event];
  }

  const events: ICalendarEvent[] = [];
  let currentDate = startDate;

  while (!currentDate.toPlainDate().equals(endDate.toPlainDate())) {
    const endOfDay = currentDate.toPlainDate()
      .toZonedDateTime({
        timeZone: currentDate.timeZoneId,
        plainTime: Temporal.PlainTime.from('23:59:00')
      });

    events.push({
      ...event,
      id: Number(event.id + 1),
      title: event.title,
      start: currentDate,
      displayStartDate: startDate,
      end: endOfDay,
      realEndDate: endDate, // Mantém o endDate original para display
      _isFirstSegment: events.length === 0, // Flag para identificar primeiro segmento
      _isLastSegment: false, // Flag para identificar último segmento
    });

    const nextDay = currentDate.toPlainDate().add({ days: 1 });
    currentDate = nextDay.toZonedDateTime({
      timeZone: currentDate.timeZoneId,
      plainTime: Temporal.PlainTime.from('00:00:00')
    });
  }

  // Último segmento
  events.push({
    ...event,
    id: Number(event.id + 1),
    title: event.title,
    start: currentDate,
    displayStartDate: startDate,
    end: endDate,
    realEndDate: endDate,
    _isFirstSegment: false,
    _isLastSegment: true, // Marca como último segmento
  });

  return events;
}

export function mapWorkScheduleToCalendarEvent(workSchedule): ICalendarEvent {
  const startDate = Temporal.ZonedDateTime.from(`${workSchedule.start_date}[America/Sao_Paulo]`);
  const endDate = Temporal.ZonedDateTime.from(`${workSchedule.end_date}[America/Sao_Paulo]`);
  const commander = workSchedule.commander.representation_name;
  const driver = workSchedule.driver ? workSchedule.driver.representation_name : null;
  const patrolmans = workSchedule.patrolmans ? workSchedule.patrolmans : [];

  return {
    id: workSchedule.id,
    title: workSchedule.name,
    start: startDate,
    end: endDate,
    realEndDate: endDate,
    calendarId: "work-schedule",
    workShiftName: workSchedule.work_shift.name,
    commander,
    driver,
    patrolmans,
  };
}

export function mapWorkScheduleListToCalendarEvents({ eventCalendar, viewMode }: WorkScheduleListToCalendarEventsParams) {
  const events = eventCalendar.map(mapWorkScheduleToCalendarEvent);

  // Só divide os eventos quando estiver na visualização de semana ou dia
  if (viewMode === 'week' || viewMode === 'day') {
    return events.flatMap((event) => splitEventAcrossDays(event));
  }

  // Para outras visualizações (month, etc), retorna os eventos sem dividir
  return events;
}